import {EventBus} from '../../event-bus.js'

export default {
	before        : (app) => {
		const $studentWorkTiles = document.querySelectorAll('.js-student-work-tile');
		
		function showModal(contents) {
			EventBus.$emit('open-global-modal', contents);
		}
		
		$studentWorkTiles.forEach(($tile) => {
			$tile.addEventListener('click', e => {
				e.preventDefault()
				let modalContents = {
					title    : '',
					image    : e.target.dataset.modalImage,
					student  : e.target.dataset.modalStudent,
					program  : e.target.dataset.modalProgram,
					className: e.target.dataset.modalClassName,
					alt      : e.target.dataset.modalAlt
				}
				showModal(modalContents)
			})
		});
		
		setTimeout(function() {
			// Play/Pause button for Video Media Header
			// ---------------------------------------------------------------------------
			const academicsVideo = document.querySelector('.academics__video-container video');
			
			if (academicsVideo) {
				const playIcon = '<img src="/assets/images/icons/icon-play.png" alt="Play background video">';
				const pauseIcon = '<img src="/assets/images/icons/icon-pause.png" alt="Pause background video">';
				document.querySelector('.academics__video-container').insertAdjacentHTML('beforeend', '<button class="control-button">' + pauseIcon + '</button>');
				const videoControlButton = document.querySelector('.academics__video-container .control-button');
				
				videoControlButton.addEventListener('click', e => {
					if (academicsVideo.paused) {
						academicsVideo.play();
						videoControlButton.innerHTML = pauseIcon;
					} else {
						academicsVideo.pause();
						videoControlButton.innerHTML = playIcon;
					}
				});
			}
		}, 500);
		
		const $playVideoButtons = document.querySelectorAll('.js-academics__video-action')
		
		$playVideoButtons.forEach($playVideoButton => {
			
			$playVideoButton.addEventListener('click', e => {
				let allVideos = Wistia.api.all()
				
				for (var i = 0; i < allVideos.length; i++) {
					allVideos[i].pause();
				}
				
				let modalContents = {
					title: '',
					video: e.target.dataset.alternate
				}
				
				showModal(modalContents)
			});
			
		})
		
		const $academicsSubmenuHeader = document.querySelector('.js-academics__menu__mobile-header');
		const $academicsSubmenuToggle = document.querySelector('.js-academics-submenu-toggle');
		const $academicsSubmenuContent = document.querySelector('.js-academics-submenu-content');
		
		$academicsSubmenuToggle.addEventListener('click', e => {
			$academicsSubmenuToggle.classList.toggle('is-active');
			$academicsSubmenuContent.classList.toggle('is-active');
			$academicsSubmenuHeader.classList.toggle('is-active');
		})
	},
	programCourses: (app) => {
		const $courses = document.querySelectorAll('.js-course-listing__course');
		
		$courses.forEach(($course) => {
			const $toggle = $course.querySelector('.js-course-listing__course-content-toggle');
			const $content = $course.querySelector('.js-course-listing__course-content');
			
			let courseIsOpen = false;
			
			$toggle.addEventListener('click', (e) => {
				if (courseIsOpen) {
					$content.style.display = 'none';
					courseIsOpen = false;
				} else {
					$content.style.display = 'block';
					courseIsOpen = true;
				}
			});
		});
	},
};


